<template>
    <div class="modal" :id="modalId()" tabindex="-1" aria-labelledby="correct_modal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content shadow-3" v-if="enrollment">
                <div class="modal-header">
                    <h5 class="mb-1" v-if="type === 'conflict'">
                        {{ $trans.get('__JSON__.Correct Shift') }}
                    </h5>
                    <h5 class="mb-1" v-else>
                        {{ $trans.get('__JSON__.Correct Shift') }}
                    </h5>
                    <small>{{ enrollment.employee }}</small>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-9">
                            <div class="row mb-5">
                                <div class="col">
                                    <h3 class="mb-5">{{ $trans.get('__JSON__.Planned Shift')}}</h3>
                                    <div class="form-group mb-5">
                                        <label>{{ $trans.get('__JSON__.Start Time') }}</label>
                                        <div class="input-group">
                                            <input type="date" class="form-control" v-model="originalStartDate" disabled>
                                            <input type="time" class="form-control" v-model="originalStartTime" disabled>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{ $trans.get('__JSON__.End Time') }}</label>
                                        <div class="input-group">
                                            <input type="date" class="form-control" v-model="originalEndDate" disabled>
                                            <input type="time" class="form-control" v-model="originalEndTime" disabled>
                                        </div>
                                    </div>
                                </div>

                                <div class="col">
                                    <h3 class="mb-5">{{ $trans.get('__JSON__.Worked Shift') }}</h3>
                                    <div class="form-check form-switch mb-5">
                                        <label for="notWorked">{{ $trans.get('__JSON__.Employee did not worked') }}</label>
                                        <input class="form-check-input" type="checkbox" id="notWorked" v-model="notWorked" :disabled="! editing">
                                    </div>
                                    <fieldset :class="{ 'd-none': notWorked }" :disabled="notWorked || ! editing">
                                        <div class="form-group mb-5">
                                            <label>{{ $trans.get('__JSON__.Correction Start Time') }}</label>
                                            <div class="input-group">
                                                <input type="date" class="form-control" v-model="enrollment.start_date">
                                                <input type="time" class="form-control" v-model="enrollment.start_time">
                                            </div>
                                        </div>
                                        <div class="form-group mb-5">
                                            <label>{{ $trans.get('__JSON__.Correction End Time') }}</label>
                                            <div class="input-group">
                                                <input type="date" class="form-control" v-model="enrollment.end_date">
                                                <input type="time" class="form-control" v-model="enrollment.end_time">
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label>{{ $trans.get('__JSON__.Break Time') }}</label>
                                            <div class="input-group">
                                                <input id="break_time" type="time" class="form-control" v-model="breakTime">
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>

                            <div class="row mb-5">
                                <div class="col">
                                    <label for="reason">{{ $trans.get('__JSON__.Reason') }}</label>
                                    <textarea id="reason" class="form-control" v-model="reason" :disabled="! editing"></textarea>
                                </div>
                            </div>

                            <div class="col">
                                <div class="row">
                                    <div class="col text-start">
                                        <strong>{{ $trans.get('__JSON__.Hours') }}</strong><br />
                                        {{ $trans.get('__JSON__.:amount hours', { amount: totalShiftHours }) }}
                                    </div>
                                    <div class="col text-center">
                                        <strong>{{ $trans.get('__JSON__.Break Time') }}</strong><br />
                                        {{ $trans.get('__JSON__.:amount min', { amount: breakInMinutes }) }}
                                    </div>
                                    <div class="col text-end">
                                        <strong>{{ $trans.get('__JSON__.Worked Hours') }}</strong><br />

                                        {{ $trans.get('__JSON__.:amount hours', { amount: totalWorkedHours }) }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-3">
                            <h3 class="mb-5">{{ $trans.get('__JSON__.Corrections')}}</h3>
                            <div class="card bg-gray-50 border ml-md-4 mb-5" v-for="mutation in enrollment.mutations">
                                <div class="card-body mb-0 pb-0">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h6 font-semibold text-muted text-sm d-block mb-2">
                                                {{ mutation.who }}
                                            </span>
                                        </div>
                                        <div class="col-auto">
                                            <span :class="`badge bg-${mutation.role.color}`">
                                                {{ mutation.role.name }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="mt-2 mb-0 text-sm" v-if="mutation.meta">
                                        <div class="text-sm text-muted" v-if="mutation.meta.not_worked">
                                            <em>{{ $trans.get('__JSON__.Employee did not worked') }}</em>
                                        </div>
                                        <table class="table text-muted mt-5" v-else>
                                            <tr v-if="mutation.meta.start_date && mutation.meta.start_time">
                                                <th>{{ $trans.get('__JSON__.Start Time') }}</th>
                                                <td class="text-end">{{ formatDateTime(mutation.meta.start_date, mutation.meta.start_time) }}</td>
                                            </tr>
                                            <tr v-if="mutation.meta.end_date && mutation.meta.end_time">
                                                <th>{{ $trans.get('__JSON__.End Time') }}</th>
                                                <td class="text-end">{{ formatDateTime(mutation.meta.end_date, mutation.meta.end_time) }}</td>
                                            </tr>
                                            <tr v-if="mutation.meta.break">
                                                <th>{{ $trans.get('__JSON__.Break Time') }}</th>
                                                <td class="text-end">{{ mutation.meta.break }}</td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="mt-2 mb-0 text-sm">
                                        <div class="mb-5">{{ mutation.reason }}</div>
                                        <span class="badge badge-pill bg-opacity-30 me-2" :class="{ 'bg-success text-success': ! mutation.isNegative, 'bg-danger text-danger': mutation.isNegative }">
                                            <i class="bi me-1" :class="{ 'bi-arrow-up': ! mutation.isNegative, 'bi-arrow-down': mutation.isNegative }"></i>
                                            {{ $trans.get('__JSON__.:amount minutes', { amount: mutation.mutationHuman }) }}
                                        </span>
                                    </div>
                                </div>
                                <div class="card-footer mt-0 pt-0">
                                    <span class="text-nowrap text-xs text-muted">{{ mutation.when }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer" v-if="isAdmin && editing">
                    <button type="button" class="btn btn-sm btn-neutral" @click="editing = false">
                        {{ $trans.get('__JSON__.Cancel') }}
                    </button>
                    <button type="button" class="btn btn-sm btn-primary" @click="save" ref="submit">
                        {{ $trans.get('__JSON__.Save') }}
                    </button>
                </div>

                <div class="modal-footer" v-else-if="isAdmin && !editing">
                    <button type="button" class="btn btn-sm btn-neutral" data-bs-dismiss="modal">
                        {{ $trans.get('__JSON__.Close') }}
                    </button>
                    <div class="btn-group">
                        <button type="button" class="btn btn-sm btn-neutral" @click="editing = true">
                            {{ $trans.get('__JSON__.Edit') }}
                        </button>
                        <button type="button" class="btn btn-sm btn-success" @click="save" ref="submit">
                            {{ $trans.get('__JSON__.Approve') }}
                        </button>
                    </div>
                </div>

                <div class="modal-footer" v-else>
                    <button type="button" class="btn btn-sm btn-neutral" data-bs-dismiss="modal">
                        {{ $trans.get('__JSON__.Close') }}
                    </button>
                    <button type="button" class="btn btn-sm btn-primary" @click="save" ref="submit">
                        {{ $trans.get('__JSON__.Save') }}
                    </button>
                </div>

<!--                <div class="modal-footer" v-if="editing">-->
<!--                    <button type="button" class="btn btn-sm btn-neutral" @click="editing = false">-->
<!--                        {{ $trans.get('__JSON__.Cancel') }}-->
<!--                    </button>-->
<!--                    <button type="button" class="btn btn-sm btn-primary" @click="save" ref="submit">-->
<!--                        {{ $trans.get('__JSON__.Save') }}-->
<!--                    </button>-->
<!--                </div>-->
<!--                <div class="modal-footer" v-else>-->
<!--                    <button type="button" class="btn btn-sm btn-neutral" data-bs-dismiss="modal">-->
<!--                        {{ $trans.get('__JSON__.Close') }}-->
<!--                    </button>-->
<!--                    <div class="btn-group">-->
<!--                        <button type="button" class="btn btn-sm btn-neutral" @click="editing = true"> &lt;!&ndash; TODO: only visible for admins &ndash;&gt;-->
<!--                            {{ $trans.get('__JSON__.Edit') }}-->
<!--                        </button>-->
<!--                        <button type="button" class="btn btn-sm btn-primary" @click="save" ref="submit">-->
<!--                            {{ $trans.get('__JSON__.Save') }}-->
<!--                        </button>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
import { DateTime, Duration } from 'luxon'
import UserHelpers from './../mixins/UserHelpers'

export default {
    name: 'MutationCorrectionModal',
    props: {
        type: {
            required: false,
            default: 'correct',
        },
        user: {
            required: true,
            default: null,
        },
        enrollment: {
            required: true,
            default: null,
        },
    },
    mixins: [UserHelpers],
    data() {
        return {
            editing: true,
            notWorked: false,
            originalStartDate: this.enrollment.start_date,
            originalStartTime: this.enrollment.start_time,
            originalEndDate: this.enrollment.end_date,
            originalEndTime: this.enrollment.end_time,
            breakTime: '00:00',
            reason: '',
        }
    },
    computed: {
        subtotal() {
            if (! this.originalStartDate || ! this.originalEndDate || ! this.originalStartTime || ! this.originalEndTime) return 0
            if (! this.enrollment.start_date || ! this.enrollment.end_date || ! this.enrollment.start_time || ! this.enrollment.end_time) return 0

            let originalStart = DateTime.fromISO(`${this.originalStartDate}T${this.originalStartTime}`)
            let originalEnd = DateTime.fromISO(`${this.originalEndDate}T${this.originalEndTime}`)

            let diffStart = originalStart.diff(DateTime.fromISO(`${this.enrollment.start_date}T${this.enrollment.start_time}`), 'minutes')
            let diffEnd = DateTime.fromISO(`${this.enrollment.end_date}T${this.enrollment.end_time}`).diff(originalEnd, 'minutes')

            return diffEnd.plus(diffStart).minutes
        },
        breakInMinutes() {
            if (! this.breakTime) return 0

            let breakTime = DateTime.fromFormat(this.breakTime, 'HH:mm')

            return Duration.fromObject({
                hours: breakTime.hour,
                minutes: breakTime.minute,
            }).as('minutes')
        },
        total() {
            return this.subtotal - this.breakInMinutes
        },
        diffShiftHours() {
            if (! this.originalStartDate || ! this.originalEndDate || ! this.originalStartTime || ! this.originalEndTime) return 0

            let start = DateTime.fromISO(`${this.originalStartDate}T${this.originalStartTime}`)
            let end = DateTime.fromISO(`${this.originalEndDate}T${this.originalEndTime}`)
            let diff = end.diff(start, 'minutes')

            return Duration.fromObject({
                minutes: diff.minutes,
            })
        },
        totalShiftHours() {
            if (! this.diffShiftHours) return 0
            return this.diffShiftHours.as('hours').toFixed(2)
        },
        totalWorkedHours() {
            if (! this.enrollment.start_date || ! this.enrollment.end_date || ! this.enrollment.start_time || ! this.enrollment.end_time) return 0

            let start = DateTime.fromISO(`${this.enrollment.start_date}T${this.enrollment.start_time}`)
            let end = DateTime.fromISO(`${this.enrollment.end_date}T${this.enrollment.end_time}`)
            let diff = Duration.fromObject({
                minutes: end.diff(start, 'minutes').minutes - this.breakInMinutes,
            })

            if (this.notWorked) diff = diff.minus({ minutes: diff.minutes })

            return diff.as('hours').toFixed(2)
        },
    },
    watch: {
        enrollment() {
            this.updateForm()
        },
    },
    methods: {
        updateForm() {
            this.editing = ! this.isAdmin
            this.originalStartDate = this.enrollment.start_date
            this.originalStartTime = this.enrollment.start_time
            this.originalEndDate = this.enrollment.end_date
            this.originalEndTime = this.enrollment.end_time

            if (this.enrollment.mutations.length === 0) return

            this.editing = false
            let clientMutation = this.enrollment.mutations.filter(it => it.type === 'client')
            if (clientMutation.length > 0) clientMutation = clientMutation[0]
            if (clientMutation) {
                if (clientMutation.meta.not_worked) {
                    this.notWorked = true
                    return
                }

                this.notWorked = false
                this.enrollment.start_date = clientMutation.meta.start_date
                this.enrollment.start_time = clientMutation.meta.start_time
                this.enrollment.end_date = clientMutation.meta.end_date
                this.enrollment.end_time = clientMutation.meta.end_time
                this.breakTime = clientMutation.meta.break
            }
        },
        formatDateTime(date, time) {
            return DateTime.fromISO(`${date}T${time}`).toFormat('D T')
        },
        save() {
            let meta = (this.notWorked) ? {
                not_worked: this.notWorked,
            } : {
                start_date: this.enrollment.start_date,
                start_time: this.enrollment.start_time.slice(0, 5),
                end_date: this.enrollment.end_date,
                end_time: this.enrollment.end_time.slice(0, 5),
                break: this.breakTime,
            }

            this.$parent.performAction(this.type, {
                amount: (this.notWorked) ? -Math.abs(this.diffShiftHours.minutes) : this.total,
                break: this.breakInMinutes,
                reason: this.reason,
                meta,
            })
        },
        clear() {
            this.editing = ! this.isAdmin
            this.notWorked = false
            this.breakTime = '00:00'
            this.reason = ''
        },
        modalId() {
            return `${this.type}_modal`
        },
    },
    mounted() {
        this.editing = ! this.isAdmin
        if (! this.modalId()) return
        this.updateForm()
        let vm = this
        let modal = document.getElementById(this.modalId())
        modal.addEventListener('hide.bs.modal', event => vm.clear())
    },
}
</script>
